<template>
<div class="chapter">
<div class="inner_page">
<p class="h2p"><a id="page_1"></a>PART IV</p>
<p class="h2p1">Narrated Time</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226713366_05_part1.vue?2be51677